import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

const TOKEN_KEY = "admin_token";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [passcode, setPasscode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await api.adminLogin(passcode);
      sessionStorage.setItem(TOKEN_KEY, token);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err.message || "Invalid passcode");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-[100dvh] bg-[#FAF9F6] pt-24 md:pt-32 pb-12 px-6" data-testid="admin-login-page">
      <div className="max-w-md mx-auto">
        <div className="text-[10px] tracking-[0.32em] uppercase font-medium text-[#1C1C1C]/60 mb-4">
          School administration
        </div>
        <h1 className="font-display text-4xl md:text-5xl leading-tight tracking-tighter font-light text-[#1C1C1C]">
          Sign in.
        </h1>

        <form onSubmit={onSubmit} className="mt-10 space-y-4">
          <input
            data-testid="admin-passcode-input"
            type="password"
            autoFocus
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            placeholder="Admin passcode"
            className="w-full px-4 py-3 bg-white border border-[#1C1C1C]/10 rounded-xl text-base focus:outline-none focus:border-[#1C1C1C]/40 transition-colors"
            disabled={loading}
          />
          {error && (
            <div className="text-sm text-[#B83A3A]" data-testid="admin-login-error">{error}</div>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading || !passcode}
            className="w-full px-5 py-3 bg-[#1C1C1C] text-[#FAF9F6] rounded-xl text-sm tracking-[0.16em] uppercase font-medium hover:bg-[#1C1C1C]/85 disabled:opacity-40 transition-colors"
          >
            {loading ? "Signing in…" : "Enter dashboard"}
          </button>
        </form>
      </div>
    </main>
  );
}

export const ADMIN_TOKEN_KEY = TOKEN_KEY;
